<template>
  <div class="container-pioneros">
      <div class="container container-fade">
        <div class="row">

            <!-- ONLY MOBILE -->
            <div class="mb-5 col-12 col-md-5 offset-md-1 align-self-center d-md-none d-block mt-3 text-center">
              <div>
                <img width="80%" :src="`${publicPath}assets/images/pionero.png`"  />
              </div>
            </div>

          <div class="col-12 col-md-6">
            <div class="linea mb-3">
              <h2 class="mb-3">{{ article.story.pioneros.title }}</h2>
            </div>
            <div class="row mt-3">
              <div class="col-12">
               <div v-html="article.story.pioneros.descripcion"></div>
              </div>

              <div class="col-12 col-md-12">
                <div class="text-center linea">
                </div>
              </div>
            </div>
          </div>

          <!-- ONLY  DESKTOP -->
          <div class="col-12 col-md-4 offset-md-1 align-self-center d-none d-md-block">
            <div>
              <img width="100%" :src="`${publicPath}assets/images/pionero.png`" />
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-12 col-md-8">
            <NominadosList :nominados="nominados" />
          </div>          
        </div>
      </div>
    </div>
</template>

<script>

import filter from 'lodash/filter'
import NominadosList from '@/components/NominadosList'

export default {
  name: 'Pioneros',
  props: {
    nominados_list: []
  },
  components: {
    NominadosList
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    article() {
      return require(`@/i18n/es.json`)
    },
    nominados() {
      return filter(this.nominados_list, ['category_id', 'pioneros'])
    }
  }
}
</script>
